import type { SubPractices } from "../config.types";

export const familyReschedule: SubPractices = {
  firstScreen: "create-meeting",
  screens: {
    "create-meeting": {
      next: async () => "contact-info-reschedule",
    },
    "contact-info-reschedule": {
      next: async () => "intake-confirmation",
      sanitize: true,
      isAuth: true,
    },
    "intake-confirmation": {
      next: async () => undefined,
    },
  },
};
